import { z } from 'zod';

export const FeaturedStatusEnum = z.enum(['HOT', 'FOLLOWING']);

export type FeaturedStatusEnum = z.infer<typeof FeaturedStatusEnum>;

export const LandingFeaturedStatusSchema = z.object({
  upcoming: FeaturedStatusEnum,
  recent: FeaturedStatusEnum,
});

export type LandingFeaturedStatusState = z.infer<typeof LandingFeaturedStatusSchema>;
